var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('navTop',{on:{"clickMenu":_vm.clickMenu}})],1),_c('router-view'),_c('goTop'),(_vm.footShow||_vm.isShow)?_c('navFoot'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }